/* eslint-disable */

import axios from 'axios';

import { encryptStorage } from '../CustomStorage';
import { APP_CONSTANTS } from '../URLConstants';
const SmartLockApiCallerInstance = axios.create({
  baseURL: process.env.REACT_APP_SMART_LOCK_HOST
});

SmartLockApiCallerInstance.interceptors.request.use(
  (request) => {
    request.headers['Authorization'] =
      `Bearer ${encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN)}`;
    return request;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

SmartLockApiCallerInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error);
    if (error?.response?.status === 401) {
      encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);
      encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN, null);
      encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_DATA, null);
      encryptStorage.setItem(APP_CONSTANTS.AWS_COGNITO_DATA, null);
      window.location.reload();
    }

    return Promise.reject(error);
  }
);

export default SmartLockApiCallerInstance;
